import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { auth, bookings as bookingsApi, getToken, setToken, clearToken } from "./damsApi";

const CustomerAuthContext = createContext(null);

export function CustomerAuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    if (!getToken()) {
      setUser(null);
      setLoading(false);
      return;
    }
    try {
      const data = await auth.me();
      setUser(data);
    } catch (_) {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const register = async ({ name, email, password, phone, adult_confirmed }) => {
    const data = await auth.register({ name, email, password, phone, adult_confirmed });
    setToken(data.token);
    // /api/auth/register returns a flat user object; fetch full profile for consistency
    const me = await auth.me();
    setUser(me);
    return me;
  };

  const login = async (email, password) => {
    const data = await auth.login({ email, password });
    setToken(data.token);
    const me = await auth.me();
    setUser(me);
    return me;
  };

  const logout = async () => {
    await auth.logout();
    clearToken();
    setUser(null);
  };

  const myBookings = () => bookingsApi.list();

  return (
    <CustomerAuthContext.Provider
      value={{
        user,
        loading,
        register,
        login,
        logout,
        refresh,
        myBookings,
      }}
    >
      {children}
    </CustomerAuthContext.Provider>
  );
}

export const useCustomerAuth = () => useContext(CustomerAuthContext);
